<div class="upcoming-events-wrapper">
    <p title>Other Upcoming Events</p>

    <div *ngIf="isLoadingUpcomingEvents" class="loading-wrap">
        <ig-spinner class="vertical-middle"></ig-spinner>
    </div>

    <div *ngIf="!isLoadingUpcomingEvents&&upcomingEvents&&!upcomingEvents.length" class="no-upcoming-events">
        <ig-no-content [fontSize]="'28px'"></ig-no-content>
    </div>
    <div *ngIf="upcomingEvents?.length" class="upcoming-events" [class.one-column]="column===1">
        <div *ngFor="let e of upcomingEvents">
            <ig-visitor-modern-block [item]="e" [isSimple]="true"
                                     (onclick)="upcomingEventClick()"></ig-visitor-modern-block>
        </div>
    </div>
    <ig-button *ngIf="!isLoadingUpcomingEvents" [class.upper-btn]="upcomingEvents.length===1||upcomingEvents.length===2" class="back-btn" size="md" (trigger)="more()">Explore more
        events
    </ig-button>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/upcoming.events/upcoming.events.component.html